import { _ } from "../../../../core/polyglot/polyglot.js";
import AccountingDocumentWidget from "../../../shared/documentInfrastructure/AccountingDocumentWidget.js";
import TitleWidget from "../../../../core/chrome/TitleWidget2.js";

/**
 * Render the forecast archive's title with a button to create a new
 * forecast template.
 */
export default class ForecastArchiveTitleWidget extends AccountingDocumentWidget {
	setup(...rest) {
		super.setup(...rest);

		this._title = new TitleWidget({
			title: this._renderTitleOn.bind(this),
		});
	}

	renderContentOn(html) {
		if (!this._title) return;
		html.render(this._title);
	}

	_renderTitleOn(html) {
		html.render(_("Published forecasts"));
	}
}
